<template>
  <div class="tab-vertical px-2">
    <!-- tab button -->
    <ul
      class="nav nav-tabs nav-tabs-simple nav-tabs-left bg-white"
      style="
        border-radius: 10px 0 0 10px;
        box-shadow: 0 0 10px rgba(184, 192, 202, 0.5) !important;
      "
      id="tab-vertical"
    >
      <li
        class="nav-item"
        v-for="(tab, index) in dataTabs"
        :key="index"
        @click="switchTab(tab)"
      >
        <a
          href="#"
          :class="index == actived ? 'active' : ''"
          data-toggle="tab"
          data-target="#tab-body"
          >{{ tab.name }}</a
        >
      </li>
    </ul>
    <!-- tab content -->
    <div
      class="tab-content bg-white"
      style="
        border-radius: 0 10px 10px 0;
        box-shadow: 0 0 10px rgba(184, 192, 202, 0.5) !important;
      "
    >
      <div class="tab-pane active" id="tab-body">
        <component
          :is="currentTab.component"
          :key="tab_key"
          :data="currentTab.data ? currentTab.data : []"
          class="tab"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tab_vertical",
  props: {
    tabs: {
      type: Array,
    },
    actived: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dataTabs: this.tabs,
      currentTab: this.tabs[this.actived],
      tab_key: 0,
    };
  },
  methods: {
    switchTab: function (tab) {
      this.currentTab = tab;
      if (this.currentTab.data && !("no_refresh" in this.currentTab)) {
        this.tab_key++;
      }
    },
  },
};
</script>